"use client"

import { memo } from "react"

export const Skeleton = ({ className = "" }) => (
	<div className={`animate-pulse rounded-md bg-(--surface-tertiary) ${className}`} />
)

export const HomePageSkeleton = memo(() => (
	<div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_300px] gap-8">
		<div className="space-y-6">
			<Skeleton className="w-full aspect-[16/9] rounded-lg" />
			<Skeleton className="h-8 w-3/4" />
			<Skeleton className="h-4 w-full" />
			<Skeleton className="h-4 w-2/3" />
			<div className="grid grid-cols-1 sm:grid-cols-2 gap-5 pt-2">
				{[1, 2, 3, 4].map((i) => (
					<div key={i} className="news-card p-3 space-y-3">
						<Skeleton className="w-full h-[140px] rounded-md" />
						<Skeleton className="h-4 w-1/4" />
						<Skeleton className="h-5 w-full" />
						<Skeleton className="h-4 w-2/3" />
					</div>
				))}
			</div>
			<Skeleton className="h-48 w-full rounded-lg" />
		</div>
		<div className="hidden lg:block space-y-6">
			<Skeleton className="h-[250px] w-full rounded-lg" />
			<Skeleton className="h-64 w-full rounded-lg" />
			<Skeleton className="h-40 w-full rounded-lg" />
		</div>
	</div>
))

HomePageSkeleton.displayName = "HomePageSkeleton"

export const CardGridSkeleton = memo(({ count = 6 }) => (
	<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
		{Array.from({ length: count }).map((_, i) => (
			<div key={i} className="news-card p-3 space-y-3">
				<Skeleton className="w-full h-[160px] rounded-md" />
				<Skeleton className="h-4 w-1/3" />
				<Skeleton className="h-5 w-full" />
			</div>
		))}
	</div>
))

CardGridSkeleton.displayName = "CardGridSkeleton"

export const DistrictGridSkeleton = memo(({ count = 8 }) => (
	<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
		{Array.from({ length: count }).map((_, i) => (
			<Skeleton key={i} className="h-16 rounded-lg" />
		))}
	</div>
))

DistrictGridSkeleton.displayName = "DistrictGridSkeleton"

export const CityWisePageSkeleton = memo(() => (
	<div className="space-y-8 md:space-y-10">
		<Skeleton className="h-[90px] w-full max-w-[728px] mx-auto rounded-lg" />
		{Array.from({ length: 5 }).map((_, sectionIndex) => (
			<div key={sectionIndex} className="space-y-4">
				<Skeleton className="h-8 w-40" />
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
					{Array.from({ length: 4 }).map((__, cardIndex) => (
						<div key={cardIndex} className="news-card p-3 space-y-3">
							<Skeleton className="w-full h-[160px] rounded-md" />
							<Skeleton className="h-4 w-1/3" />
							<Skeleton className="h-5 w-full" />
						</div>
					))}
				</div>
			</div>
		))}
	</div>
))

CityWisePageSkeleton.displayName = "CityWisePageSkeleton"

export const NivadakPageSkeleton = memo(() => (
	<div className="space-y-8 md:space-y-10">
		{Array.from({ length: 2 }).map((_, sectionIndex) => (
			<div key={sectionIndex} className="space-y-4">
				<Skeleton className="h-8 w-32" />
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
					{Array.from({ length: 4 }).map((__, cardIndex) => (
						<div key={cardIndex} className="news-card p-3 space-y-3">
							<Skeleton className="w-full h-[160px] rounded-md" />
							<Skeleton className="h-4 w-1/3" />
							<Skeleton className="h-5 w-full" />
						</div>
					))}
				</div>
			</div>
		))}
	</div>
))

NivadakPageSkeleton.displayName = "NivadakPageSkeleton"

export const ListingPageFallback = memo(() => (
	<div className="site-container py-4 md:py-5">
		<Skeleton className="h-10 w-64 mb-3" />
		<Skeleton className="h-5 w-96 max-w-full mb-8" />
		<CardGridSkeleton count={9} />
	</div>
))

ListingPageFallback.displayName = "ListingPageFallback"

export const EmptyState = memo(({ message = "सध्या कोणतीही बातमी उपलब्ध नाही." }) => (
	<div className="text-center py-16 px-6 bg-white border border-(--border-default) rounded-xl min-w-0">
		<p className="mr m-0 text-(--text-tertiary) break-words [overflow-wrap:anywhere]">{message}</p>
	</div>
))

EmptyState.displayName = "EmptyState"
